require('./locations.less');

class LocationsController {
    locations;
    defaultSearchParams = {pageSize: 100, pageNo: 0, sort: ""};
    activeSearchParams;

    searchDefinition = {
        fields: [
            {title: 'Lokasjon', name: 'text', type: 'text'},
        ],
        searchParams: Object.assign({}, this.defaultSearchParams),
        searchFunction: (params) => this.locationSearch(params),
    };

    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: "Søk etter lokasjoner",
        buttons: [
            {
                func: () => this.searchDefinition.searchParams = Object.assign({}, this.defaultSearchParams),
                tooltip: "Slett søkedata",
                materialicon: "delete_sweep"
            },
        ],
    };

    tableDefinition = {
        columns: [
            {title: 'Lokasjon', name: 'id', noOrderBy: true},
            {title: 'Sone', name: 'zoneId', noOrderBy: true},
            {title: 'Type', name: 'type', noOrderBy: true},
            {title: 'Sperret', name: 'blocked', noOrderBy: true, type: 'boolean'}
        ],
        settings: {
            editFunction: (ev, item) => this.openItemCard(ev, item),
            onPaginate: (page, limit) => this.changePage(page, limit),
            promise: null,
            totalElements: null,
            initialPageSize: 100,
            title: 'Lokasjonsoversikt'
        }
    };

    constructor(private toastService, private Locations, private $location, private $state, private $mdDialog) {
    }

    $onInit() {
    }

    locationSearch(params) {
        this.activeSearchParams = params;
        this.tableDefinition.settings.promise = this.Locations.getLocations(params).$promise.then(
            (results) => {
                this.locations = results.content;
                this.tableDefinition.settings.totalElements = results.totalElements;
            }, (error) => {
                this.toastService.parseError(error);
            }
        )
    };

    changePage(page, limit) {
        this.activeSearchParams.pageNo = page - 1;
        this.activeSearchParams.pageSize = limit;
        this.$location.search(this.activeSearchParams);
    }

    openItemCard(event, item) {
        this.$state.go("loggedin.expedition_basicdata_locations_locationdetails", {locationId: item.id})
    }

    createLocation(event) {
        this.$mdDialog.show({
            template: '<create-location-dialog></create-location-dialog>',
            targetEvent: event,
            clickOutsideToClose: false
        }).then((success) => {
            if (success === 'created') {
                this.$location.search(this.activeSearchParams);
            }
        });
    }
}

class LocationsOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcLocationsController";
    public template: any = require('./locations.html');
}

rkcApp.controller("rkcLocationsController", ['toastService', 'Locations', '$location', '$state', '$mdDialog', function (toastService, Locations, $location, $state, $mdDialog) {
    return new LocationsController(toastService, Locations, $location, $state, $mdDialog);
}])
    .component("rkcLocations", new LocationsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/locations/locations.ts
 **/